import * as fromActions from './store/signal-r.actions'

import { SignalRState } from 'modules/signal-r'

type OperationMap = Partial<Record<Operations, any>>

/**
 * If you want to trigger init action for some operation when is registered,
 * that action must be placed here.
 */
export const operationToInitActionMap: OperationMap = {
  FeedbackNotificationCount: fromActions.FeedbackBadgeInitAction,
  GoalNotificationCount: fromActions.GoalBadgeInitAction,
  ReviewNotificationCount: fromActions.ReviewBadgeInitAction,
  MyTeamNotificationCount: fromActions.MyTeamBadgeInitAction,
  TeamGoalsNotificationCount: fromActions.TeamGoalBadgeInitAction,
  TeamReviewNotificationCount: fromActions.TeamReviewBadgeInitAction,
}

export const operationToActionMap: OperationMap = {
  FeedbackNotificationCount: fromActions.NotificationFeedbackCountAction,
  GoalNotificationCount: fromActions.NotificationGoalCountAction,
  ReviewNotificationCount: fromActions.NotificationReviewCountAction,
  MyTeamNotificationCount: fromActions.NotificationMyTeamCountAction,
  TeamGoalsNotificationCount: fromActions.NotificationTeamGoalCountAction,
  TeamReviewNotificationCount: fromActions.NotificationTeamReviewCountAction,
}

export type Operations = keyof SignalRState



// WEBPACK FOOTER //
// ./src/modules/signal-r/operation-action-map.ts